const testR = new RegExp(/cpt-tab="(.*)"/g);
// let path = "./test.vue";

export const testH = function (content: string): string {
  console.log(content);

  return content.toString().replace(testR, function (a: string) {
    const id = a.match(new RegExp(/[0-9]{6}/g));
    console.log(id);

    //   if (!json[$1.trim()]) {
    //     o[$1.trim()] = "???";
    //   }
    return ``;
  });
};

export const isMobile =
  function () {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
  }